import { Logger } from '~/helpers/logger';
import { useApi } from '~/composables/useApi';
import {
  CREATE_COMPARE_LIST,
  COMPARE_LIST,
  ADD_PRODUCTS_TO_COMPARE_LIST,
  REMOVE_PRODUCTS_FROM_COMPARE_LIST,
  DELETE_COMPARE_LIST,
  ASSIGN_COMPARE_LIST_TO_CUSTOMER,
} from './gql';

export const useCompareApi = () => {
  const { query, mutate } = useApi();

  const createCompareList = async (input: object) => {
    Logger.debug('[Magento]: Create Compare List', { input });

    const data = await mutate(
      CREATE_COMPARE_LIST,
      {...input},
    );

    Logger.debug('[Result]:', { data });

    return data;
  };

  const compareList = async (input: object) => {
    Logger.debug('[Magento]: Query Compare List', { input });

    const data = await query(
      COMPARE_LIST,
      {...input},
    );

    Logger.debug('[Result]:', { data });

    return data;
  };

  const addProductsToCompareList = async (input: object) => {
    Logger.debug('[Magento]: Add products to Compare List', { input });

    const data = await mutate(
      ADD_PRODUCTS_TO_COMPARE_LIST,
      {...input},
    );

    Logger.debug('[Result]:', { data });

    return data;
  };

  const removeProductsFromCompareList = async (input: object) => {
    Logger.debug('[Magento]: Remove products from Compare List', { input });

    const data = await mutate(
      REMOVE_PRODUCTS_FROM_COMPARE_LIST,
      {...input},
    );

    Logger.debug('[Result]:', { data });

    return data;
  };

  const deleteCompareList = async (input: object) => {
    Logger.debug('[Magento]: Delete Compare List', { input });

    const data = await mutate(
      DELETE_COMPARE_LIST,
      {...input},
    );

    Logger.debug('[Result]:', { data });

    return data;
  };

  const assignCompareListToCustomer = async (input: object) => {
    Logger.debug('[Magento]: Assign Compare List to Customer', { input });

    const data = await mutate(
      ASSIGN_COMPARE_LIST_TO_CUSTOMER,
      {...input},
    );

    Logger.debug('[Result]:', { data });

    return data;
  };

  return {
    createCompareList,
    compareList,
    addProductsToCompareList,
    removeProductsFromCompareList,
    deleteCompareList,
    assignCompareListToCustomer,
  };
};

export default useCompareApi;
